import { Component, Input } from '@angular/core';

// Company-page step 6 (Associate Vendors to BU) - see company-page.component.ts's
// mapping notes: this panel (company-page.html's old data-step="6",
// lines 464-526) is shown only when TypeOfCompany is BusinessUnit.
//
// Like-for-like display port: `vendors` is bound by reference from the root
// legacy controller, so the checkbox's `[(ngModel)]` mutates
// `vendors.vendorDtoList[i].isSelected` directly on the same object the root
// controller reads from getModifiedVendors()/saveVendorsOnComplete() - no
// output events needed, same pattern as company-page-step-license-scoring's
// `preferences` binding.
@Component({
  selector: 'app-company-page-step-vendors',
  templateUrl: './company-page-step-vendors.component.html'
})
export class CompanyPageStepVendorsComponent {

  @Input() vendors: any = {};
  @Input() readOnlyForClientOrBU: boolean;
}
